import { render, staticRenderFns } from "./DashboardLandingPage.vue?vue&type=template&id=d5624022&"
import script from "./DashboardLandingPage.vue?vue&type=script&lang=js&"
export * from "./DashboardLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports